import { atomFamily } from 'jotai/utils';
import { PendingQueue } from '../util';
export const safeAtomFamily = (initializeAtom, areEqual) => {
    let family = null;
    const initializeAtomWrapper = (param) => {
        const atom = initializeAtom(param);
        if (typeof window === 'undefined') {
            PendingQueue.instance.push(() => {
                family?.remove(param);
            });
        }
        return atom;
    };
    family = atomFamily(initializeAtomWrapper, areEqual);
    return family;
};
